export const getExpressionField = ({
  value,
  defaultExpressions,
  relationalReport
}) => {
  const expressionAlias = value.replace('.', '');
  const defaultExpression = defaultExpressions.find(expression => expression.value.alias === expressionAlias);
  const existingExpressions = relationalReport.get('expressions');
  const expressionExists = existingExpressions && existingExpressions.find(expression => {
    return expression.get('alias') === expressionAlias;
  });
  return defaultExpression && !expressionExists ? defaultExpression.value : undefined;
};